'use strict'

export function stripHtml() {

  'ngInject';

  return function (val) {
    val = val || ''
    return val
      .replace(/<(?:.|\n)*?>/gm, ' ')
      .replace(/&amp;/g, '&')
  }
}



// WEBPACK FOOTER //
// ./app/filters/strip-html.filter.js